import { createSelector } from '@reduxjs/toolkit';

const selfSelect = state => state;

export const getUserList = state =>
  createSelector(selfSelect, state => {
    return state.list;
  })(state);

export const getTotalUsers = state =>
  createSelector(selfSelect, state => {
    return state.totalEntries;
  })(state);

// it receives the whole state and extracts the filter from required piece of slice
export const createSelectors = selectState => ({
  getUserList: state => getUserList(selectState(state)),
  getTotalUsers: state => getTotalUsers(selectState(state)),
});
